import React, { type FC, type PropsWithChildren } from 'react'

import type { ReadonlyRecord } from '../../../utils'

export const createFormatter = <T,>(Renderer: FC<PropsWithChildren<T>>, props: T & ReadonlyRecord<`data-${string}`, string>): FC => (...chunks) => (
    <Renderer {...props}>{chunks}</Renderer>
)

export const boldFormatter = createFormatter((props) => <b {...props} />, {})
